import React from 'react'
import './SobreMi.css'

const SobreMi = () => {
  return (
    <section className="sobreMi-container" id="sobre-mi">
      <h2>Sobre mí</h2>

      <article className="sobreMi-content">
        <p>
          Soy la <strong>Dra. Ana Lourdes Barber Sahig</strong>,
          <strong> Médico Especialista en Endocrinología</strong> con más de tres décadas de experiencia dedicada
          al estudio y tratamiento de <strong>enfermedades hormonales, metabólicas y tiroideas</strong>.
        </p>

        <p>
          Mi formación se inició en <strong>La Habana, Cuba</strong>, donde obtuve el título de
          <strong> Doctora en Medicina</strong> (Universidad de La Habana, 1984)
          y posteriormente la especialidad en <strong>Endocrinología</strong> (Universidad de La Habana, 1995).
          Más tarde, en Chile, obtuve el título de <strong>Médico Cirujano</strong> en la
          <strong> Universidad de Chile</strong> (1998), consolidando así mi trayectoria internacional
          en medicina y endocrinología clínica.
        </p>

        <p>
          A lo largo de mi carrera he ejercido en instituciones de alto nivel como el
          <strong> Hospital Universitario Manuel Fajardo</strong> y el
          <strong> Instituto Nacional de Endocrinología y Metabolismo</strong> en Cuba, además de formar parte
          del <strong>Hospital San José</strong> y el <strong>Hospital Salvador</strong> en Santiago de Chile.
          Desde 2003 desempeño mi labor en <strong>consulta privada</strong>, donde ofrezco atención integral
          centrada en la persona, basada en evidencia científica y con una mirada empática hacia cada paciente.
        </p>

        <p>
          Mi compromiso con la actualización constante me ha llevado a participar en
          <strong> congresos y programas internacionales</strong> en endocrinología, metabolismo, diabetes,
          obesidad y climaterio, tanto en Chile como en el extranjero.
          He asistido y contribuido en eventos organizados por instituciones como
          <strong> Harvard Medical International</strong>, la
          <strong> Sociedad Chilena de Endocrinología y Metabolismo</strong>, la
          <strong> Endocrine Society (EE. UU.)</strong> y la
          <strong> Sociedad Latinoamericana de Tiroides</strong>, entre muchas otras.
        </p>

        <p>
          Esta formación continua me permite mantenerme al día con los avances más recientes en diagnóstico
          y tratamiento endocrinológico, especialmente en áreas como
          <strong> diabetes mellitus, cáncer tiroideo, riesgo cardiovascular</strong>
          y <strong>salud hormonal femenina</strong>.
        </p>

        <p>
          Entre mis publicaciones destaca el estudio:
          <em>
            “Utilidad de la detección de tiroglobulina en el aspirado de punción ganglionar cervical
            en el seguimiento de pacientes con cáncer papilar de tiroides”,
          </em> publicado en la
          <strong> Revista Médica de Chile</strong> (2008; 136:1107–1112).
        </p>

        <p>
          Mi vocación es acompañar a mis pacientes en cada etapa del tratamiento,
          entregando un <strong>enfoque médico integral, humano y actualizado</strong>,
          con el objetivo de mejorar su bienestar hormonal, metabólico y general.
        </p>

        {/* Botón CTA */}
        <div className="sobreMi-cta">
          {/* Botón con link externo */}
        <a
          href="http://agendamiento.softwaremedilink.com/agendas/online/c71a6edfe2b8fb65d605ebdefa75a0d5cc60bd4f"
          target="_blank"
          rel="noopener noreferrer"
          className="hero-button"
        >
          Reservar Cita
        </a>
        </div>
      </article>
    </section>
  )
}

export default SobreMi
